<template>
  <div id="app" class="activity-collapsed guide-collapsed">
    <router-view :key="$route.fullPath"/>

    <!-- 404 modal template -->
    <b-modal ref="404-modal" hide-footer @hide="hide404Modal">
      <div class="d-block text-center">
        <h1 qid="not-found-modal-title">
          {{ $t('error.not_found.title') }}
        </h1>
      </div>
      <br>
      <h5 class="text-center">
        {{ $t('error.not_found.description_1') }}
      </h5>
      <h5 class="text-center">
        {{ $t('error.not_found.description_2') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="success"
                  @click="goToHomepage"
                  qid="homepage-button"
        >
          {{ $t('error.not_found.homepage_button') }}
        </b-button>
      </div>
      <div class="text-right">
        <b-button class="mt-5"
                  variant="secondary"
                  @click="hide404Modal"
                  qid="not-found-close-button"
        >
          {{ $t('error.not_found.close_button') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import piincHttp from './util/configureAxios.js'
import {config} from '@/config.js'

export default {
  components: {

  },
  data: function() {
    return {
      user: {}
    }
  },
  computed: {

  },
  methods: {
    isPublicRoute(route) {
      let publicRouteNames = ['resetPassword', 'verify', 'register', 'Token', 'login'];
      let publicRoutePaths = ['/password/reset', '/email/verify', '/register', '/token', '/login'];

      return publicRouteNames.indexOf(route.name) !== -1 || publicRoutePaths.some(function(path) {
        return route.path && route.path.indexOf(path) === 0;
      });
    },
    getUser() {
      // Keep reference in variable becauce of async functions
      let self = this;
      let selectedClient;

      if (this.$store.state.isLoggedIn && !this.isPublicRoute(this.$route)) {

        // Call api/me for logged in user details
        piincHttp.get('users/me').then(function(response) {
          self.user = response.data.user;
          self.clients = response.data.clients;
          self.user.clients = self.clients;
          // store logged in user in store
          self.$store.commit('storeUser', self.user);

          piincHttp.get('settings/guide_url').then(function(response) {
            self.$store.commit('storeWordpressLink', response.data.value);
          }, function() {});

          // Check if we have selected client in local storage
          let clientSlug = localStorage.getItem('client');
          if (clientSlug) {
            let currentClient = false;
            _.forEach(self.clients, function(client) {
              if(client.slug === clientSlug){
                currentClient = client;
                selectedClient = client;
              }
            })
            if (!currentClient) {
              localStorage.removeItem('client')
              selectedClient = self.clients[0]
            }
          } else {
            // If there's no selected client in local storage,
            // set first one to be selected
            selectedClient = self.clients[0]
          }

          piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
            selectedClient.user_permissions = response.data.user_permissions
            selectedClient.user_roles = response.data.user_roles

            piincHttp.get('clients/' + selectedClient.slug + '/trial').then(function(response) {

              selectedClient.onTrial = response.data.on_trial
              selectedClient.subscribed = response.data.subscribed
              selectedClient.trial_ends_at = response.data.trial_ends_at
              selectedClient.subscription_status = response.data.subscription_status
              localStorage.setItem('clientObject', JSON.stringify(selectedClient));
              localStorage.setItem('client', selectedClient.slug);
              self.$store.commit('storeClient', selectedClient);

            }, function() {});

          }, function() {});

        }, function() {

        });
      }
    },
    goToHomepage() {
      this.hide404Modal()
      this.$router.push('/')
    },
    show404Modal() {
      this.$refs['404-modal'].show()
    },
    hide404Modal() {
      this.$refs['404-modal'].hide()
    },
  },
  // Lifecycle hooks
  mounted() {

  },
  created() {

    // Keep the reference in variable because if you use 'this' inside
    // a function below, it will refer to the function itself
    let self = this;

    // Load the user right away. The route guards for deep links (?client=... and
    // /maintenance/...) wait for the user in the store, but onReady only fires after
    // the guards finish, so loading the user from onReady alone never completes.
    let userRequested = false;
    if (!self.isPublicRoute({ path: window.location.pathname })) {
      userRequested = true;
      self.getUser();
    }

    self.$router.onReady(function() {
      if (!userRequested && !self.isPublicRoute(self.$router.currentRoute)) {
        self.getUser();
      }
    })

    // Read uploaded files into memory before sending them. If a file changes size while it's
    // being sent (e.g. a OneDrive/SharePoint file that isn't fully downloaded yet), the browser
    // sends more bytes than it announced and the server receives a cut-off upload without its
    // form fields. A copy in memory can't change, so the announced size always matches.
    piincHttp.interceptors.request.use(function(config) {
      if (!(config.data instanceof FormData)) {
        return config;
      }
      const entries = Array.from(config.data.entries());
      if (!entries.some(function(entry) { return entry[1] instanceof File; })) {
        return config;
      }
      return Promise.all(entries.map(function(entry) {
        const value = entry[1];
        if (!(value instanceof File)) {
          return entry;
        }
        return value.arrayBuffer().then(function(buffer) {
          return [entry[0], new File([buffer], value.name, { type: value.type, lastModified: value.lastModified })];
        });
      })).then(function(copies) {
        const formData = new FormData();
        copies.forEach(function(entry) {
          formData.append(entry[0], entry[1]);
        });
        config.data = formData;
        return config;
      }, function() {
        // Same shape as a server error, so upload handlers show the message they already read
        return Promise.reject({
          response: {
            status: 0,
            data: { message: self.$t('system.file_read_error'), errors: {} }
          }
        });
      });
    });

    // Add a response interceptor
    piincHttp.interceptors.response.use(function(response) {

      if (response.status == 200) {
        // 200 OK response actions
      }
      return response;
    }, function(error) {
      // Do something with response error
      if (error && error.response) {
        console.log(error)
        // 413 = upload larger than the server accepts (nginx, PHP or Laravel).
        // Give upload handlers a translated message in the shape they already read.
        if (error.response.status === 413) {
          error.response.data = {
            message: self.$t('system.file_size_30'),
            errors: {}
          };
        }
        // redirect to 404 page when status is 404
        if (error.response.status === 404) {
          if (error.response.data.code == 'rest_post_invalid_id') {

          } else {
            //self.$router.push('/404')
          }

        }
        // redirect to 403 page when status is 403
        if (error.response.status === 403) {
          //self.$router.push('/403');
        }
        // redirect to login when status is 401
        if (error.response.status === 401) {
          if (!self.isPublicRoute(self.$route)) {
            if (error.response.data.code == 'rest_forbidden') {

            } else {
              self.$router.push('/login');
            }

          }

        }
      }
      return Promise.reject(error.response);
    });


  }
}
</script>

<style lang="scss">

</style>
